import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js'
import RenderField from './RenderField';
import SelectField from './SelectField';
import AttributeOptions from './AttributeOptions';
import FieldInformation from './FieldInformation';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import FlowProgressBar from './FlowProgressBar';

class Affidavit extends Component {

    constructor(props){
        super(props);
        this.state = {
            showSourceOfFundsDetail: false
        }
        this.checkSourceOfFundsValue = this.checkSourceOfFundsValue.bind(this);
    }

    checkSourceOfFundsValue(value){
        if(value == 3){
            this.setState({showSourceOfFundsDetail: true})
        }else{
            this.setState({showSourceOfFundsDetail: false})
            this.props.deleteReduxFormField('source_of_funds_description');
        }
    }

    render() {
        const { showSourceOfFundsDetail } = this.state;
        const { handleSubmit, submitting, error } = this.props;

        const sourceOfFundsDetailField = (
            <div className="col-xs-12 col-md-12 col-lg-12 vcenter">
                <div className="form-group">
                    <Field
                        className="form-control"
                        name="source_of_funds_description"
                        autoComplete="off"
                        component={RenderField}
                        label={'Detallar el origen de fondos'}
                        type={'textarea'}
                        fieldInfo={{
                            title: 'Detalle de origen de fondos',
                            info: 'Adicionalmente la Entidad podrá solicitar la documentación respaldatoria que justifica el origen de fondos.',
                        }}
                    />
                </div>
            </div>
        );
        return (
              <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_affidavit" description="Affidavit info"/>
                        </div>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <FlowProgressBar/>
                        <form onSubmit={handleSubmit(this.props.sentAffidavit)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field
                                            className="form-control"
                                            name="public_figure"
                                            component={RenderField}
                                            showLabel={false}
                                            type="switch"
                                            label="¿Sos una persona expuesta políticamente (P.E.P.)?"
                                            fieldInfo={{
                                                title: '¿Qué significa ser una Persona Expuesta Políticamente?',
                                                info: 'Son los funcionarios públicos, diplomáticos, sus cónyugues o convivientes reconocidos legalmente y familiares en línea ascendiente, descendiente o colateral hasta el tercer grado.',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field
                                            className="form-control"
                                            name="bound_subject"
                                            component={RenderField}
                                            type="switch"
                                            label="¿Sos Sujeto Obligado ante la U.I.F.?"
                                            fieldInfo={{
                                                title: '¿Qué significa ser Sujeto Obligado?',
                                                info: 'Son las personas que están obligadas al cumplimiento de obligaciones destinadas a prevenir, impedir y detectar el lavado de dinero.',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field
                                            className="form-control"
                                            name="foreign_tax_residence"
                                            component={RenderField}
                                            type="switch"
                                            label="¿Sos residente fiscal en un país distinto de la República Agentina?"
                                            fieldInfo={{
                                                title: 'Debés responder afirmativamente si reunís alguna de las siguientes condiciones:',
                                                info: '1) Pagás impuestos por tenencia de bienes o actividades realizadas en otro/s país/es.<br/>2) Tenés un número de identificación tributaria emitido por otro/s país/es.',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field
                                            className="form-control"
                                            name="american_person"
                                            component={RenderField}
                                            type="switch"
                                            label="¿Sos persona estadounidense a los efectos de F.A.C.T.A.?"
                                            fieldInfo={{
                                                title: 'Debés responder afirmativamente si reunís alguna de las siguientes condiciones:',
                                                info: '1) Ciudadano estadounidense con Pasaporte estadounidense.<br/>2) Residente en Estados Unidos o sus estados asociados con Tarjeta de Residencia (Green Card)<br/>3) Residente Parcial en Estados Unidos o sus estados asociados (183 días en 1 año calendario, o 122 días en promedio en los últimos 3 años calendario.)',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{marginTop: '15px'}}>
                                <div className="col-md-12 col-lg-12">
                                    Origen de fondos: <FieldInformation title={'Origen de fondos'} info={'Por el presente manifiesto bajo juramento de decir la verdad en cuanto a que todos los fondos y valores entregados o que se entreguen en el futuro a Montemar C.F.S.A., son y serán de fuente lícita.<br/>Asimismo, manifiesto que toda información proporcionada a Montemar C.F.S.A., es exacta, completa y verdadera y me comprometo a informar de inmediato cualquier cambio que se produzca en el futuro; asimismo reconozco y acepto que Montemar C.F.S.A. podrá en cualquier momento solicitar información adicional y/o actualización de la misma en cumplimiento con lo establecido por la ley 25.246 y las Resoluciones vigentes emitidas por la UIF.'}/>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 vcenter"> Mis fondos provienen de:</div>
                                <div className="col-xs-12 col-md-7 col-lg-7 vcenter">
                                    <div className="form-group">
                                        <AttributeOptions
                                            name="source_of_funds"
                                            defaultValue="Seleccionar un Origen"
                                            label="Seleccionar un Origen"
                                            attributeName='source_of_funds'
                                            attributeOptions={[
                                                {id:1, name: 'Ingresos/Ahorros personales provenientes de la actividad profesional'},
                                                {id:2, name: 'Laboral o comercial'},
                                                {id:3, name: 'Otro'}
                                            ]}
                                            onChange={this.checkSourceOfFundsValue}
                                        />
                                    </div>
                                </div>
                                {showSourceOfFundsDetail && sourceOfFundsDetailField}
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

let validate = generateValidator([
    {name: 'source_of_funds', required: true},
    {name: 'source_of_funds_description', required: true}
]);

Affidavit = TopScrolleable(Affidavit);

Affidavit = reduxForm({
    initialValues: {
        public_figure: false,
        bound_subject: false,
        foreign_tax_residence: false,
        american_person: false,
    },
    form: 'Affidavit', // a unique name for this form
    validate: validate
})(Affidavit);

Affidavit = withAuthControl(Affidavit);

export default Affidavit;



/** WEBPACK FOOTER **
 ** ./src/components/Affidavit.js
 **/